<template>
  <v-card>
    <v-spacer></v-spacer>
    <v-toolbar
        elevation="1"
        color="#BC0000"
        dark
    >
        <v-card-title class="d-flex justify-center align-center mb-4">
          <h2>Cadastro de grupo de atributo</h2>
        </v-card-title>

        <v-btn absolute top right color="#ccc" icon @click="close">
          <v-icon size="22">mdi-close</v-icon>
        </v-btn>
    </v-toolbar>

    <v-card-text >
      <span class="label mx-2">
        Selecione um atributo pre cadastrado e clique em adicionar. Adicione
        quantos atributos quiser
      </span>

      <v-form ref="form" v-model="valid">
        <v-row class="pa-0 ma-0">
          <v-col cols="12" sm="12" md="12" lg="12">
            <div>
              <span class="">Nome do grupo de atributo</span>
              <v-text-field
                clearable
                outlined
                :rules="[(v) => !!v || 'Campo obrigatório']"
                v-model="currentAttributeGroup.name"
                placeholder="Nome do grupo"
                required
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                hide-details
              ></v-text-field>
            </div>
          </v-col>
        </v-row>

        <v-row class="pa-0 ma-0" align="end" justify="center">
          <v-col cols="12" sm="6" md="6" lg="6">
            <span class="ml-2">Tipo de atributo</span>
            <v-select
              style="border-radius: 7.5px; font-weight: normal !important"
              append-icon="mdi-chevron-down"
              placeholder="Seleção"
              hide-details
              clearable
              color="white"
              background-color="normalred"
              dark
              full-width
              outlined
              :items="attributes"
              item-text="name"
              item-value="id"
              v-model="currentAttributeId"
              required
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="6">
            <div>
              <v-btn
                class="add-button"
                width="100%"
                outlined
                @click="addAttribute"
                elevation="0"
                large
              >
                Adicionar atributo
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <div
          v-for="(
            addedAttribute, i
          ) in currentAttributeGroup.attributeGroupAttributes"
          :key="i"
        >
          <div class="dividers pl-2 pt-2 pb-2 mb-3">
            <span class="pl-2"> {{ addedAttribute.attribute.name }}</span>

            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    tile
                    style="border-radius: 6px"
                    small
                    @click="removeLine(i)"
                    v-bind="attrs"
                    color="red"
                    v-on="on"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
                <span>Remover</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    tile
                    style="border-radius: 6px"
                    small
                    @click="addLine(addedAttribute)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Adicionar</span>
              </v-tooltip>
            </div>
          </div>

          <v-divider />

          <v-row
            v-for="(item, j) in addedAttribute.attributeGroupItems"
            :key="j"
            justify="space-between"
          >
            <v-col cols="12" sm="6" md="6" lg="6">
              <span
                class="ml-2 mb-2"
                v-if="addedAttribute.attribute.type != 'Cor'"
              >
                Nome da variação
              </span>
              <v-text-field
                v-if="addedAttribute.attribute.type != 'Cor'"
                outlined
                v-model="item.name"
                :rules="[(v) => !!v || 'Campo obrigatório']"
                placeholder="Nome da variação"
                style="border: 1px solid #979797; border-radius: 7.5px"
                color="black"
                background-color="#F5F5F5"
                hide-details
              ></v-text-field>

              <v-row
                align="center"
                justify="space-around"
                v-if="addedAttribute.attribute.type == 'Cor'"
              >
                <v-col
                  cols="12"
                  sm="2"
                  md="2"
                  lg="2"
                  class="d-flex justify-center"
                >
                  <v-menu top :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <div
                        style="min-width: 150px"
                        class="d-flex flex-column justify-center"
                      >
                        <div :style="switchStyle(item.hex)" v-on="on" />
                        <span class="color-field mt-2 mx-auto"
                          >Adicionar cor</span
                        >
                      </div>
                    </template>
                    <v-card class="ma-0">
                      <v-card-text class="pa-0">
                        <v-color-picker
                          v-model="item.hex"
                          flat
                          hide-sliders
                          mode="hexa"
                          show-swatches
                          swatches-max-height="130"
                        />
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                  class="d-flex flex-column justify-center"
                >
                  <span class="pl-2">Nome da variação</span>
                  <v-text-field
                    placeholder="Nome da cor"
                    v-model="item.name"
                    :rules="[(v) => !!v || 'Campo obrigatório']"
                    class="elevation-0"
                    outlined
                    style="border: 1px solid #979797; border-radius: 7.5px"
                    color="black"
                    background-color="#F5F5F5"
                    hide-details
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>

            <v-col
              class="d-flex justify-end align-center"
              cols="12"
              sm="6"
              md="6"
              lg="6"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    fab
                    tile
                    style="border-radius: 6px"
                    small
                    class="table-button ma-1 edit-button"
                    color="normalred"
                    @click="
                      removeItem(
                        item,
                        addedAttribute.attributeGroupItems,
                        addedAttribute
                      )
                    "
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </div>

        <v-divider />
      </v-form>
    </v-card-text>

    <v-card-actions class="btns-down mx-4">
      <v-row class="row-down ma-0">
        <v-col class="btns-down" cols="12" sm="6" md="6" lg="6">
          <v-btn
            class="cancel-button"
            @click="close"
            elevation="0"
            outlined
            width="100%"
          >
            Cancelar
          </v-btn>
        </v-col>

        <v-col class="btns-down" cols="12" sm="6" md="6" lg="6">
          <v-btn
            class="cadaster-button"
            elevation="1"
            dark
            width="100%"
            @click="submit"
          >
            <span >Cadastrar </span>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
.cancel-button {
  border-radius: 7.5px;
  transition: 0.3s;
}

.cancel-button:hover {
  color: white !important;
  background: #000000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
}

.cadaster-button {
  border-radius: 7.5px;
  transition: 0.3s;
  background: #bc0000 !important;
}

.cadaster-button:hover {
  color: white !important;
  background: #e8161e !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
}

.color-field {
  font-weight: 300;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.15px;
  color: #979797;
}

.add-button {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #bc0000;
  box-sizing: border-box;
  border-radius: 10px;
  transition: 0.3s;
}

.add-button:hover {
  color: #fff !important;
  background: #bc0000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.label {
  font-weight: 300;
  font-size: 18px;
  line-height: 35px;
  color: #9c9c9c;
}

.config {
  font-weight: bold;
  background-color: #ffffff !important;
  border: 1px solid #bc0000 !important;
  box-sizing: border-box;
  border-radius: 10px;
  height: 50px;
}

.cssTable {
  text-align: center;
  vertical-align: middle;
}

.linha-end {
  justify-content: flex-end;
}
.btns-down {
  text-align: -webkit-center;
}

.dividers {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f5f5f5;
  border-radius: 4px;
  font-weight: bold;
}

.row-down {
  justify-content: space-evenly;
}
</style>

<script scoped>
import ApiService from "../../../../../services/ApiService";
import Vue from "vue";

export default {
  name: "NewAttributeGroup",

  props: {
    textMessage: String,
    icone: String,
    title: String,
    route: String,
    typeRoute: String,
    attributeGroup: Object,
  },

  created() {
    this.updateAtributes();

    if (this.attributeGroup != null) {
      this.currentAttributeGroup = this.attributeGroup;
      this.isEditing = true;
    } else {
      this.currentAttributeGroup = {
        attributeGroupAttributes: [],
      };
    }
  },

  mounted() {},

  data: () => ({
    valid: true,
    pickerColor: "",
    textMenu: false,
    loading: false,
    currentAttributeGroup: {
      attributeGroupAttributes: [],
    },
    attributes: [],
    loading: false,
    isEditing: false,
    apiService: new ApiService(),
    currentAttributeId: 0,
    newAttributeDialog: false,
    filter: {
      page: 1,
      pageSize: 15,
    },
    headers: [
      { text: "Cor", align: "center", class: "item", value: "name" },
      {
        text: "Nome da variação",
        class: "item",
        value: "name",
        align: "center",
      },
      {
        text: "Ações",
        class: "item",
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],

    headerProps: {
      sortByText: "Ordenar por",
    },
  }),

  computed: {},

  methods: {
    switchStyle(color, menu) {
      return {
        border: "2px dashed #DADADA",
        boxSizing: "border-box",
        backgroundColor: color,
        cursor: "pointer",
        height: "52px",
        width: "56px",
        margin: "0 auto 0 auto",
        borderRadius: menu ? "50%" : "10px",
        transition: "border-radius 200ms ease-in-out",
      };
    },

    changeName(item) {
      if (item.hex) {
        item.hex = item.hex;
      } else {
        item.name = item.name;
      }
    },

    addAttribute() {
      this.loading = true;
      this.isLoading = true;

      let attribute = this.attributes.find(
        (x) => x.id == this.currentAttributeId
      );

      let findAttributeId =
        this.currentAttributeGroup.attributeGroupAttributes.find(
          (x) => x.attributeId == this.currentAttributeId
        );

      if (!findAttributeId) {
        this.currentAttributeGroup.attributeGroupAttributes.push({
          attribute: attribute,
          attributeId: attribute.id,
          attributeGroupItems: [],
        });
      }
    },

    verifyError() {
      let error = false;

      this.currentAttributeGroup.attributeGroupAttributes.forEach((group) => {
        if (group.attributeGroupItems.length == 0) {
          error = true;
        }
      });

      if (error) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "Formulário não validado",
          message: "Um grupo de atributos não está preenchido",
          trace: null,
        });
      }

      return error;
    },

    async submit() {
      this.loading = true;

      if (this.$refs.form.validate() && !this.verifyError()) {
        let url = "AttributesGroup/add";

        if (this.isEditing) {
          url = "AttributesGroup/edit";
        }

        await this.apiService
          .post(url, this.currentAttributeGroup)
          .then((resp) => {
            let token = localStorage.getItem("token");
            if (token) {
              this.close();
            } else {
              this.$router.push("/auth");
            }

            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: resp.message,
              message: resp.message,
              trace: null,
            });

            this.loading = false;
          })
          .catch((err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Erro ao cadastrar produto",
              message: err.body.message,
              trace: null,
            });

            this.loading = false;
          });
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "Formulário não validado",
          message: "Confira o preenchimento",
          trace: null,
        });

        this.loading = false;
      }
    },

    removeLine(i) {
      this.currentAttributeGroup.attributeGroupAttributes.splice(i, 1);
    },

    addLine(item) {
      item.attributeGroupItems.push({ name: "", hex: "" });
    },

    async updateAtributes() {
      this.loading = true;
      this.isLoading = true;

      await this.apiService
        .post(`attribute/list`, this.filter)
        .then((response) => {
          this.totalPages = response.pager.totalPages;
          response.attributes.forEach((e) => {
            this.attributes.push(e);
          });
          this.loading = false;
          this.isLoading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.deleteDialog = false;
        });
    },

    close() {
      this.$emit("close");
    },

    async removeItem(value, items, attributes) {
      items = items.filter(function (item) {
        return item !== value;
      });

      let index =
        this.currentAttributeGroup.attributeGroupAttributes.indexOf(attributes);

      this.currentAttributeGroup.attributeGroupAttributes[
        index
      ].attributeGroupItems = items;
    },
  },
};
</script>
